import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogContent, Button, Radio, Checkbox, IconButton,  Select, InputLabel, MenuItem } from '@material-ui/core'
import { History } from '@material-ui/icons'

import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import useStore from 'store'
import { getProtocolPermissions } from './permissions'
import ProtocolStatusHistoryView from './ProtocolStatusHistoryView'
import { STATUS_MAP, getIconByStatus } from './statusMap'
import { APPROVMENT_STATUS_MAP } from './approvmentStatusMap'
import { protocolFileName, cleanImportedText, htmlToPlainText } from './textUtils'
import Export from 'assets/icons/Export.svg'

import {
  DialogHeaderBlue,
  Header,
  StyledClose,
  StyledIconButton,
  StyledIconButtonWhite,
  CategoryListTitleContainer,
  CategoryListTitleSubContainer1,
  CategoryListTitleSubContainer2,
  HeaderTitle1,
  HeaderTitle2,
  ImageHeader,
  NewCategoryBody,
  NewCategoryContainerColumn,
  NewCategoryContainerActions,
} from './CategoryModal.styles'

import FileIcon from 'assets/icons/ims/File.svg'
import User4Icon from 'assets/icons/ims/User4.svg'
import DocIcon from 'assets/icons/protocols/icon12.svg'
import ShareIcon from 'assets/icons/protocols/icon13.svg'
import PrintIcon from 'assets/icons/protocols/icon14.svg'
import PeopleIcon from 'assets/icons/protocols/icon15.svg'
import PeopleIcon2 from 'assets/icons/protocols/icon16.svg'
import MessageIcon from 'assets/icons/protocols/icon17.svg'
import CheckIcon from 'assets/icons/protocols/icon18.svg'
import DocIcon2 from 'assets/icons/protocols/icon19.svg'
import FileIcon3 from 'assets/icons/protocols/icon21.svg'
import DownloadIcon from 'assets/icons/protocols/icon22.svg'
import SecondaryFileIcon from 'assets/icons/protocols/icon23.svg'
import ApprovedStatusIcon from 'assets/icons/protocols/icon10.svg'


const HeaderDialogButton = styled(Button)`
  display: flex;
  height: 39.986px;
  margin-right: 10px;
  padding-left: 15.994px;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.20);
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #101828;
  font-family: Rubik;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  /* @noflip */ direction: rtl;
  width: 100%;
`
const SectionDot = styled.span<{ color?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${p => p.color ?? '#3B82F6'};
  flex-shrink: 0;
`

const SectionBody = styled.div`
  color: #4C5564;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  /* @noflip */ direction: rtl;
  /* @noflip */ text-align: right;
  width: 100%;
  white-space: pre-line;
`

const CategoryBadge = styled.div<{ color: string; bg: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: ${p => p.bg};
  color: ${p => p.color};
  font-family: Rubik;
  font-size: 13px;
  font-weight: 500;
`

const ParticipantRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  /* @noflip */ direction: rtl;
  width: 100%;
  padding: 6px 0;
  border-bottom: 0.5px solid #F1F5F9;
  &:last-child { border-bottom: none; }
`

const ParticipantName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
`

const ParticipantRole = styled.div`
  color: #4C5564;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
`

const ApproverRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
`
const ApproverName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`

const FileCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background: #F8FAFC;
  /* @noflip */ direction: rtl;
  width: 100%;
  box-sizing: border-box;
`

const FileInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const FileName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`

const FileSize = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
`

const DownloadButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #EFF6FF;
  color: #1C398E;
  text-decoration: none;
  flex-shrink: 0;
  &:hover { background: #DBEAFE; }
`
const ImageHeaderBlue = styled(Image)`
 padding-left: 5px;
`
const FileIconImg = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`
const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #F1F5F9;
`
const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
  width: 100%;
`
const MetaRow = styled.div`
  display: flex;
  gap: 20px;
  /* @noflip */ direction: rtl;
  color: #64748B;
  font-family: Rubik;
  font-size: 13px;
`
const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`
const ImportExportImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const CategoryViewContainer = styled.div`
  border-radius: 8px;
  padding: 50px;
  border: 0.909px solid #E5E7EB;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const CloseButton = styled(Button)`
  border-radius: 8px;
  background: #E5E7EB;
  display: flex;
  padding: 8px 24px 8px 24px;
  justify-content: center;
  align-items: center;
  color: #364153;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
// Blue-framed "watch the status-change log" (audit) button.
const StatusHistoryButton = styled(Button)`
  gap: 6px;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 8px;
  border: 1.818px solid #3B82F6;
  background: rgba(59, 130, 246, 0.08);
  color: #3B82F6;
  font-family: Rubik;
  font-weight: 500;
  line-height: 20px;
  text-transform: none;
  &:hover { background: rgba(59, 130, 246, 0.16); }
`
// Publishing straight from the view screen - same action as the edit screen's
// publish button, for a Category Manager who only wants to release the protocol.
const PublishButton = styled(Button)`
  display: flex;
  height: 39.986px;
  padding: 8px 18px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #9810FA;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
  color: #FFF;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-transform: none;
  white-space: nowrap;
  &:hover { background: #8200DB; }
  &.Mui-disabled { background: #E5E7EB; color: #9CA3AF; }
`
const PublishIcon = styled(Image)`
  filter: brightness(0) invert(1);
`
// Left-hand cluster of Container1: current-status badge + action buttons.
const Container1Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`
const CurrentStatusWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: Rubik;
  font-size: 14px;
  color: #6A7282;
`
export const CurrentStatusBadge = styled.div<{ $color: string; $bg: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 25.795px;
  padding: 5px 9px;
  border-radius: 9999px;
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  border: 1px solid ${p => p.$color};
  color: ${p => p.$color};
  background: ${p => p.$bg};
`
export const StatusBadgeIcon = styled(Image)`
  width: 16px;
  height: 16px;
`
const Container1 = styled.div`
  display: flex;
  width: 100%;
  height: 65px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.909px solid #E5E7EB;
`
const TextStyle1 = styled.div`
  color: #6A7282;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
// Rejection reason shown (in red) at the top of the view when a protocol
// is rejected.
const RejectReasonText = styled.div`
  align-self: stretch;
  color: #E7000B;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: right;
`
const ButtonStyled1 = styled.div`
  display: flex;
  padding: 10px 18px 10px 18px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1.818px solid #3B82F6;
  background: rgba(59, 130, 246, 0.08);
  color: #3B82F6;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; 
`
const TitleStyled1 = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 7.585px;
  align-self: stretch;
  color: #1E2939;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

`
const ContainerStyled1 = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;  
  gap: 7.997px;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-self: stretch;
`
const ContainerVerticalStyled1  = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;  
  flex-direction: column;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`

const ContainerContent1 = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  margin-top: 20px;
`
const UserCard = styled.div`
  display: flex;
  padding-left: 12px;
  padding-right: 12px;
  height: 38px;
  align-items: center;
  gap: 7.997px;
  border-radius: 8px;
  border: 1px solid #BEDBFF;
  background: #EFF6FF;
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const ItemCard = styled.div`
  display: flex;
  /* min-height, not height: an imported topic can be long enough to wrap, and a
     fixed height would let the extra lines spill out of the card. */
  min-height: 21.989px;
  padding-right: 0;
  align-items: flex-start;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
// The text sits in its own box so it can break. A flex item will not shrink
// below its content until told it may (min-width: 0), and an imported topic
// often has no spaces to break on - hence overflow-wrap, which breaks mid-run
// only when there is nowhere else to break.
const ItemText = styled.div`
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
  /* A topic is written in Hebrew whichever language the interface is in, so it
     is pinned rather than left to follow the interface. Both declarations are
     @noflip: without it on text-align the English stylesheet mirrors 'right'
     into 'left' and the Hebrew ends up against the wrong edge. */
  /* @noflip */ direction: rtl;
  /* @noflip */ text-align: right;
`
const ItemNumber = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  /* Keep the circle round once the text beside it wraps. */
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #155DFC;
  color: #FFF;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
const Container1Text = styled.div`
  /* Block, not flex: the content is a single run of text and the line breaks,
     wrapping and per-line direction below have to apply to it directly. */
  display: block;
  padding: 26px 24px 24px 36px;
  text-align: right;
  /* Imported descriptions are plain text with real line breaks; keep them, and
     let each line pick its own base direction so mixed Hebrew/English content
     stays readable. */
  white-space: pre-wrap;
  overflow-wrap: break-word;
  /* @noflip */ direction: rtl;
  unicode-bidi: plaintext;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
`
const MainFileContainer = styled.div`
  display: flex;
  width: 100%;
  height: 91.619px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1.818px solid #51A2FF;
  background: linear-gradient(90deg, #EFF6FF 0%, #DBEAFE 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
  /* The row opens the file, so the whole of it is the target - the file name
     alone was a few characters wide. */
  cursor: pointer;
`
const DownloadMainFileButton = styled(Button)`
  display: flex;
  padding: 12px 20px 12px 20px;
  justify-content: center;
  align-items: flex-start;
  gap: 7.594px;
  border-radius: 8px;
  background: #155DFC;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
`
const IconMainFileContainer = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  margin-left: 10px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  background: #155DFC;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
`
const MainFileDetailsContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  wisth: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 3.992px;
  flex-shrink: 0;
`
const MainFileName = styled.div`
color: #101828;
font-family: Rubik;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 24px;
`
// Clickable file name — opens the file in a new tab for reading.
const ClickableFileName = styled(MainFileName)`
  cursor: pointer;
  &:hover { color: #1447E6; text-decoration: underline; }
`
const MainFileSize = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const MainFileBadge = styled.div`
  display: flex;
  padding: 2px 8px 2px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #155DFC;
  color: #FFF;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`
const MainFileDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  align-self: stretch;
`
const TitleStyled2 = styled.div`
  width: 100%;
  display: flex;
  height: 20px;
  padding: 0 8px 0 8px;
  justify-content: flex-start;
  align-items: center;
  color: #4C5564;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`
const SecondaryFileContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
  background: #F9FAFB;
  /* The row opens the file, so the whole of it is the target - the file name
     alone was a few characters wide. */
  cursor: pointer;
`
const DownloadSecondaryFileButton = styled(Button)`
  display: flex;
  padding: 8px 16px 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 7.963px;
  border-radius: 8px;
  background: #4C5564;
  color: #FFF;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`
const IconSecondaryFileContainer = styled.div`
  display: flex;
  margin-left: 10px;
  width: 36px;
  height: 36px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  background: #D1D5DC;
`

const formatFileSize = (bytes: number): string => {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}


const ProtocolViewModal = ({ open, protocolId, onClose }: { open: boolean; protocolId: number | null; onClose: () => void }) => {
  const { t } = useTranslation('protocols')
  const { protocolsStore } = useStore()
  const data = protocolsStore.protocolView
  const loading = protocolsStore.loadingProtocolView
  const perms = getProtocolPermissions(protocolsStore.userPermissions)

  const [showStatusHistory, setShowStatusHistory] = useState(false)
  const [publishing, setPublishing] = useState(false)

  useEffect(() => {
    setShowStatusHistory(false)
  }, [protocolId])

  const handleClose = () => {
    setShowStatusHistory(false)
    onClose()
  }

  const handlePublish = async () => {
    if (!protocolId) return
    setPublishing(true)
    try {
      const res = await protocolsStore.publishProtocol(protocolId)
      // Closing reloads the list, so the published protocol shows its new status.
      if (res) handleClose()
    } catch (err) {
      console.error('ProtocolViewModal.handlePublish failed', err)
    } finally {
      setPublishing(false)
    }
  }

  // A Category Manager can publish a protocol that is still Pending Approval once
  // at least one approver has approved it (approvment status 2).
  const canPublishProtocol = !!data
    && perms.canPublish(data.categoryId)
    && data.protocolStatusId === 2
    && !!data.approvers?.some(a => a.statusId === 2)

  const dateStr = data?.protocolDate ? new Date(data.protocolDate).toLocaleDateString('he-IL') : ''
  const modifiedStr = data?.modifiedDate ? new Date(data.modifiedDate).toLocaleDateString('he-IL') : ''
  const statusId = data?.protocolStatusId ?? 0
  const status = data
    ? (STATUS_MAP[statusId] || { titleKey: String(statusId), color: '#4C5564', bg: '#F1F5F9' })
    : null

  return (
    <Dialog style={{ zIndex: 1200 }} open={open} fullWidth maxWidth="md" scroll="body">
      {showStatusHistory && protocolId ? (
        <ProtocolStatusHistoryView
          protocolId={protocolId}
          protocolTitle={cleanImportedText(data?.title)}
          protocolDate={data?.protocolDate}
          onBack={() => setShowStatusHistory(false)}
        />
      ) : (
      <>
      <DialogHeaderBlue>
        <Header style={{ background: 'linear-gradient(90deg, #155DFC 0%, #1447E6 100%)'  }}>
          <CategoryListTitleContainer>
            <CategoryListTitleSubContainer2>
              <ImageHeader src={DocIcon} />
            </CategoryListTitleSubContainer2>
            <CategoryListTitleSubContainer1>
              <HeaderTitle1 style={{ color: 'white' }}>
                {cleanImportedText(data?.title) || t`view_title`}
              </HeaderTitle1>
              <HeaderTitle2>
                <MetaRow style={{ color: '#DBEAFE' }}>
                  {dateStr && <MetaItem>{t`protocol_date`} {dateStr}</MetaItem>}
                  {modifiedStr && <MetaItem>{t`updated`} {modifiedStr}</MetaItem>}
                  {data?.creatorName && <MetaItem>{t`author`} {data.creatorName}</MetaItem>}
                </MetaRow>
              </HeaderTitle2>
            </CategoryListTitleSubContainer1>
          </CategoryListTitleContainer>
          {/*<>
          <HeaderDialogButton><ImageHeaderBlue src={PrintIcon} /> {t`print_protocol`}</HeaderDialogButton>
          <HeaderDialogButton><ImageHeaderBlue src={ShareIcon} /> {t`share_protocol`}</HeaderDialogButton>
          </>*/}
          <StyledIconButtonWhite onClick={handleClose}><StyledClose /></StyledIconButtonWhite>
        </Header>
      </DialogHeaderBlue>

      <DialogContent>
        <CategoryViewContainer>
          {loading && <SpinnerWrap><Spinner /></SpinnerWrap>}

          {!loading && data && (
            <>
              <Container1>
                <Container1Actions>
                  {status && (
                    <CurrentStatusWrap>
                      {t`current_status`}
                      <CurrentStatusBadge $color={status.color} $bg={status.bg}>
                        <StatusBadgeIcon src={getIconByStatus(statusId)} /> {t(status.titleKey)}
                      </CurrentStatusBadge>
                    </CurrentStatusWrap>
                  )}
                  <ButtonStyled1>{t`meeting_summaries`}</ButtonStyled1>
                  {perms.canViewStatusHistory(data.categoryId) && (
                    <StatusHistoryButton onClick={() => setShowStatusHistory(true)}><History style={{ fontSize: 18 }} /> {t`status_change_log`}</StatusHistoryButton>
                  )}
                  {canPublishProtocol && (
                    <PublishButton onClick={handlePublish} disabled={publishing}>
                      {publishing ? <Spinner size={16} /> : <><PublishIcon src={ApprovedStatusIcon} /> {t`publish`}</>}
                    </PublishButton>
                  )}
                </Container1Actions>
                <TextStyle1>{t`last_updated`} {modifiedStr}</TextStyle1>
              </Container1>

              {data.protocolStatusId === 4 && data.rejectReason && (
                <RejectReasonText>{t`reject_reason_inline`} {data.rejectReason}</RejectReasonText>
              )}

              {perms.canViewApprovers(data.categoryId) && data.approvers?.length > 0 &&
              <ContainerContent1>
                <TitleStyled1><Image src={User4Icon}/> {t`approvers`}</TitleStyled1>
                <ContainerVerticalStyled1>
                  {data.approvers.map((a, i) => {
                    const approvmentStatus = APPROVMENT_STATUS_MAP[a.statusId] || { titleKey: a.statusName, color: '#4C5564', bg: '#F1F5F9', icon: undefined }
                    return (
                      <ApproverRow key={i}>
                        <ApproverName>{a.approverName}</ApproverName>
                        <CurrentStatusBadge $color={approvmentStatus.color} $bg={approvmentStatus.bg}>
                          {approvmentStatus.icon && <StatusBadgeIcon src={approvmentStatus.icon} />} {t(approvmentStatus.titleKey)}
                        </CurrentStatusBadge>
                      </ApproverRow>
                    )
                  })}
                </ContainerVerticalStyled1>
              </ContainerContent1>
              }

              <ContainerContent1>
                <TitleStyled1><Image src={PeopleIcon}/> {t`participants`} {`(${data.participants.length})`}</TitleStyled1>
                <ContainerStyled1>
                  {data.participants.map((p, i) => (
                    <UserCard key={i}>
                      <Image src={PeopleIcon2}/>
                      <ParticipantName>{p.participantName}</ParticipantName>
                      {p.participantRole && <ParticipantRole> • {p.participantRole}</ParticipantRole>}
                    </UserCard>
                  ))}
                </ContainerStyled1>
              </ContainerContent1>

              {data.topics && (
               <ContainerContent1>
                <TitleStyled1><Image src={MessageIcon}/> {t`topics`}</TitleStyled1>
                <ContainerVerticalStyled1>
                  {data.topics.split(/[;\n]/).map(t => cleanImportedText(t)).filter(Boolean).map((t, i) => (
                    <ItemCard key={i}><ItemNumber>{i+1}</ItemNumber><ItemText>{t}</ItemText></ItemCard>
                  ))}
                </ContainerVerticalStyled1>
              </ContainerContent1>
              )}

              {data.decisions &&
              <ContainerContent1>
                <TitleStyled1><Image src={CheckIcon}/> {t`decisions`}</TitleStyled1>
                <ContainerVerticalStyled1>
                  {data.decisions.split(/[;\n]/).map(d => d.trim()).filter(Boolean).map((d, i) => (
                    <ItemCard key={i}><ItemNumber>{i+1}</ItemNumber><ItemText>{d}</ItemText></ItemCard>
                  ))}
                </ContainerVerticalStyled1>
              </ContainerContent1>
              }

              {data.description && 
              <ContainerContent1>
                <TitleStyled1><Image src={DocIcon2}/> {t`description`}</TitleStyled1>
                <Container1Text>
                  {htmlToPlainText(data.description)}
                </Container1Text>
              </ContainerContent1>
              }

              {(data.mainFile || data.attachments?.length > 0) &&
              <ContainerContent1>
                <TitleStyled1><Image src={FileIcon3}/> {t`attachments`}</TitleStyled1>
                <ContainerVerticalStyled1>

                {data.mainFile &&
                  <MainFileContainer
                    title={t`open_in_new_tab`}
                    onClick={() => protocolsStore.openProtocolFile(protocolId, data.mainFile.id, protocolFileName(data.mainFile))}
                  >
                    <IconMainFileContainer>
                      <ImageHeaderBlue src={DocIcon} />
                    </IconMainFileContainer>

                    <MainFileDetailsContainer>
                      <MainFileDetails>
                        <ClickableFileName>{protocolFileName(data.mainFile)}</ClickableFileName>
                        <MainFileBadge>{t`main_file_badge`}</MainFileBadge>
                      </MainFileDetails>
                      <MainFileSize>{formatFileSize(data.mainFile.fileSize)}</MainFileSize>
                    </MainFileDetailsContainer>

                    <DownloadMainFileButton onClick={e => {
                      // The row opens the file; this button saves it instead.
                      e.stopPropagation()
                      protocolsStore.downloadProtocolFile(protocolId, data.mainFile.id, protocolFileName(data.mainFile))
                    }}>
                      <ImageHeaderBlue src={DownloadIcon} /> {t`download_protocol`}
                    </DownloadMainFileButton>
                  </MainFileContainer>
                }

                {data.attachments?.length > 0 && <>
                <TitleStyled2>{t`more_files`} ({data.attachments.length})</TitleStyled2>
                {data.attachments?.map((file, i) => (
                  <SecondaryFileContainer
                    key={file.id ?? i}
                    title={t`open_in_new_tab`}
                    onClick={() => protocolsStore.openProtocolFile(protocolId, file.id, protocolFileName(file))}
                  >
                    <IconSecondaryFileContainer>
                      <ImageHeaderBlue src={SecondaryFileIcon} />
                    </IconSecondaryFileContainer>

                    <MainFileDetailsContainer>
                      <MainFileDetails>
                        <ClickableFileName>{protocolFileName(file)}</ClickableFileName>
                      </MainFileDetails>
                      <MainFileSize>{formatFileSize(file.fileSize)}</MainFileSize>
                    </MainFileDetailsContainer>

                    <DownloadSecondaryFileButton onClick={e => {
                      e.stopPropagation()
                      protocolsStore.downloadProtocolFile(protocolId, file.id, protocolFileName(file))
                    }}>
                      <ImageHeaderBlue src={DownloadIcon} /> {t`download`}
                    </DownloadSecondaryFileButton>
                  </SecondaryFileContainer>
                ))}
                </>
                }
                </ContainerVerticalStyled1>
              </ContainerContent1>
            }
           
            </>
          )}
        </CategoryViewContainer>
        <NewCategoryContainerActions style={{ paddingRight: 0 }}>
          <CloseButton onClick={handleClose}>{t`close`}</CloseButton>
        </NewCategoryContainerActions>
      </DialogContent>
      </>
      )}
    </Dialog>
  )
}

export default observer(ProtocolViewModal)
